import { render, staticRenderFns } from "./BaseEtymTable.vue?vue&type=template&id=617bc9b9&scoped=true&"
import script from "./BaseEtymTable.vue?vue&type=script&lang=js&"
export * from "./BaseEtymTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseEtymTable.vue?vue&type=style&index=0&id=617bc9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bc9b9",
  null
  
)

export default component.exports